import { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { getCreditCheckAPI } from '@/api/shopApi'
import { Translation } from '@/components/i18n/Translation'
import {
  getIsCreditCheckStatus,
  getTempOrderId,
  setCreditCheckDocumentId,
  setCreditCheckStatus,
} from '@/ducks/shopOrderReducer'
import { useInterval } from '@/hooks/useInterval'
import { CREDIT_CHECK_STATUS, getCreditCheckTextId } from '@/util/credit-check'
import { SEC } from '@/util/formatters/dates'

import CreditCheckResultDocNeeded from './CreditCheckResultDocNeeded'
import CreditCheckStatusIcon from './CreditCheckStatusIcon'

import './credit-check-result.scss'
// @ts-ignore
const getComponent = status => {
  switch (status) {
    case CREDIT_CHECK_STATUS.DOC_REQUIRED:
      return CreditCheckResultDocNeeded
    case CREDIT_CHECK_STATUS.APPROVED:
      return CreditCheckResultApproved
    case CREDIT_CHECK_STATUS.REJECTED:
      return CreditCheckResultRejected
    case CREDIT_CHECK_STATUS.PENDING:
    default:
      return CreditCheckResultPending
  }
}

const CreditCheckResult = () => {
  const dispatch = useDispatch()

  const tempOrderId = useSelector(getTempOrderId)

  const [description, setDescription] = useState()
  const [docDetails, setDocDetails] = useState([])
  const [documents, setDocuments] = useState([])
  const [id, setId] = useState()

  const loadCreditCheck = async () => {
    // @ts-ignore
    const { id, status, description, documentation_details, document_id, documents } =
      await getCreditCheckAPI(tempOrderId)

    dispatch(setCreditCheckStatus(status))
    dispatch(setCreditCheckDocumentId(document_id))

    setDescription(description)
    setDocDetails(documentation_details)
    setDocuments(documents)
    setId(id)
  }

  useInterval(loadCreditCheck, 30 * SEC)

  const status = useSelector(getIsCreditCheckStatus)

  const Component = getComponent(status)

  return (
    <Component
      loadCreditCheck={loadCreditCheck}
      // @ts-ignore
      description={description}
      docDetails={docDetails}
      documents={documents}
      id={id}
    />
  )
}

export default CreditCheckResult

const CreditCheckResultPending = ({ description }: any) => (
  <div className="credit-check-result">
    <CreditCheckStatusIcon status={CREDIT_CHECK_STATUS.PENDING} />

    <h2>
      <Translation id={getCreditCheckTextId(CREDIT_CHECK_STATUS.PENDING)} />
    </h2>

    {description && <p>{description}</p>}
  </div>
)

const CreditCheckResultApproved = () => (
  <div className="credit-check-result">
    <CreditCheckStatusIcon status={CREDIT_CHECK_STATUS.APPROVED} />

    <h2>
      <Translation id={getCreditCheckTextId(CREDIT_CHECK_STATUS.APPROVED)} />
    </h2>
  </div>
)

const CreditCheckResultRejected = () => (
  <div className="credit-check-result">
    <CreditCheckStatusIcon status={CREDIT_CHECK_STATUS.REJECTED} />

    <h2>
      <Translation id={getCreditCheckTextId(CREDIT_CHECK_STATUS.REJECTED)} />
    </h2>

    <p>
      <Translation id="Try changing your order and resubmit!" />
    </p>
  </div>
)
